import { getMessage } from '../../../../../util/IntlMessages'

export const actionStatus = {
  DONE: 'REALIZADA',
  PLANNED: 'PLANEJADA',
  NOT_PLANNED: 'NÃO PLANEJADA'
}

export const actionStatusMap = new Map([
  [actionStatus.DONE, 15],
  [actionStatus.PLANNED, 14],
  [actionStatus.NOT_PLANNED, 13]
])

export const validationMessages = {
  actionSubjectMsg: getMessage('isRequired', getMessage('actionsDescription')),
  actionTypeIdMsg: getMessage('isRequired', getMessage('actionsType')),
  actionStatusIdMsg: getMessage('isRequired', getMessage('actionStatus')),
  customerIdMsg: getMessage('isRequired', getMessage('actionsCustomer')),
  memberIdMsg: getMessage('isRequired', getMessage('actionsMember')),
  referencePeriodIdMsg: getMessage('isRequired', getMessage('referencePeriod')),
  actionPlannedDoneTimeMsg: getMessage('isRequired', getMessage('actionPlannedDoneTime')),
  /*
    [Suporte #46638] Visitas - Remover campo "Hora" do formulário principal
    USER STORY 10613 (AzureDevops)
  */
  // actionsPlannedTimeHourMsg: getMessage('isRequired', getMessage('actionsPlannedTimeHour')),
  locationMsg: getMessage('isRequired', getMessage('location')),
  actionsLocationMsg: getMessage('isRequired', getMessage('actionsLocation'))
}
